import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {HeaderComponent} from './components/header/header';
import {ConsumptionTable} from './components/consumption-table/consumption-table';
import {ConsumptionChart} from './components/consumption-chart/consumption-chart';
import {LoginService} from './services/login.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    ConsumptionTable,
    ConsumptionChart
  ],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  isIframe = false;
  title = 'Verbrauchsansicht';

  constructor(private loginService: LoginService) {}


  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal


  }

}
